import React from 'react';

// 2-letter vendor monogram with a deterministic gradient. Square by default
// so it reads distinctly from person Avatars (which are circular). Used in
// the TPRM list/detail headers to give each vendor a consistent visual.
// The gradient palette lives in tokens.css as --monogram-1 … --monogram-N.
const MONOGRAM_GRADIENT_COUNT = 9;

export default function VendorMonogram({ name, size = 28, square = true, style }) {
  const letters =
    (name || '?')
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0])
      .join('')
      .toUpperCase() || '?';
  const seed = (name || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return (
    <span
      style={{
        display: 'inline-grid',
        placeItems: 'center',
        width: size,
        height: size,
        borderRadius: square ? Math.max(4, size * 0.22) : 999,
        background: `var(--monogram-${(seed % MONOGRAM_GRADIENT_COUNT) + 1})`,
        color: 'var(--color-base-white)',
        fontFamily: 'var(--font-family-mono)',
        fontWeight: 500,
        fontSize: Math.max(9, size * 0.4),
        letterSpacing: 0.5,
        flexShrink: 0,
        ...style,
      }}
    >
      {letters}
    </span>
  );
}
